// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"373e746f","635":"06834a8b"}[chunkId] + ".chunk.js";
};